import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/vercel/path1/node_modules/@babel/runtime/regenerator/index.js";
import servicesUtils from "../utils/servicesUtils";
import Store from "../utils/Store";
export var getUserSettings = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var settingsData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return servicesUtils.getService("/settings/");
        case 2:
          settingsData = _context.sent;
          Store.update(function (store) {
            // eslint-disable-next-line no-param-reassign
            store.userSettings = settingsData && settingsData.settings ? settingsData : {};
          });
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getUserSettings() {
    return _ref.apply(this, arguments);
  };
}();
export var getAppConfig = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var configData;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return servicesUtils.getService("/configs/");
        case 2:
          configData = _context2.sent;
          Store.update(function (store) {
            // eslint-disable-next-line no-param-reassign
            store.appConfig = configData || {};
          });
          return _context2.abrupt("return", configData);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function getAppConfig() {
    return _ref2.apply(this, arguments);
  };
}();